export default __webpack_public_path__ + "static/media/new.f9a2d5c2.svg";